<template>
  <el-checkbox v-model="value" @update:modelValue="input">
    Block WebView traffic
    <IconWithHint>
      Traffic without website header<br />
      (usually this is traffic from apps<br />
      that can open websites)
    </IconWithHint>
  </el-checkbox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'BlockWebView',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const input = (newValue: boolean) => {
      context.emit('update:modelValue', newValue)
    }

    return { input, value }
  }
})
</script>
